import { ROUTES } from "routes/constants";
import { useTranslation } from 'react-i18next';

export const useSections = () => {
  const { t } = useTranslation();
  
  return {
    SECTIONS: {
      '1': t('settings.sectionsButtonSelector.sections.calendar'),
      '2': t('settings.sectionsButtonSelector.sections.salonManagement'),
      '3': t('settings.sectionsButtonSelector.sections.clients'),
      '4': t('settings.sectionsButtonSelector.sections.payments'),
      '5': t('settings.sectionsButtonSelector.sections.statistics'),
      '6': t('settings.sectionsButtonSelector.sections.notifications'),
      '7': t('settings.sectionsButtonSelector.sections.communications'),
      '8': t('settings.sectionsButtonSelector.sections.shop'),
      '9': t('settings.sectionsButtonSelector.sections.reviews'),
      '10': t('settings.sectionsButtonSelector.sections.advertising'),
    },
    SUBSECTIONS: [
      {   id: 1,
          title: t('settings.sectionsButtonSelector.sections.calendar'),
          link: ROUTES.SCHEDULER,
          options: [
            {name: t('settings.sectionsButtonSelector.options.viewAll'), field: 'viewJustMe', value: 0}, 
            {name: t('settings.sectionsButtonSelector.options.singleView'), field: 'viewJustMe', value: 1}, 
            {name: t('settings.sectionsButtonSelector.options.insert'), field: 'allowInsert', value: 1}, 
            {name: t('settings.sectionsButtonSelector.options.edit'), field: 'allowEdit', value: 1}
          ]
        },
        {
          id: 2,
          title: t('settings.sectionsButtonSelector.sections.salonManagement'),
          link: ROUTES.SALON_MANAGEMENT,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 3,
          title: t('settings.sectionsButtonSelector.sections.clients'),
          link: ROUTES.CLIENTS,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 4,
          title: t('settings.sectionsButtonSelector.sections.payments'),
          link: ROUTES.PAYMENTS,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 5,
          title: t('settings.sectionsButtonSelector.sections.statistics'),
          link: ROUTES.STATISTICS,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 6,
          title: t('settings.sectionsButtonSelector.sections.notifications'),
          link: ROUTES.NOTIFICATION,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 7,
          title: t('settings.sectionsButtonSelector.sections.communications'),
          link: ROUTES.COMMUNICATIONS,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 8,
          title: t('settings.sectionsButtonSelector.sections.shop'),
          link: ROUTES.SHOP,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 9,
          title: t('settings.sectionsButtonSelector.sections.reviews'),
          link: ROUTES.REVIEWS,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
        {
          id: 10,
          title: t('settings.sectionsButtonSelector.sections.advertising'),
          link: ROUTES.ADVERTISING,
          options: [{name: t('settings.sectionsButtonSelector.options.allOperations'), field: 'allowAll', value: 1}]
        },
    ]
  };
};

// Keep the old exports for backward compatibility
export const SECTIONS = {
    '1': 'Calendario',
    '2': 'Gestione Salone',
    '3': 'Clienti',
    '4': 'Pagamenti',
    '5': 'Statistiche',
    '6': 'Notifiche',
    '7': 'Comunicazioni',
    '8': 'Shop',
    '9': 'Recensioni',
    '10': 'Pubblicità',
};

export const SUBSECTIONS = [
    {   id: 1,
        title: 'Calendario',
        link: ROUTES.SCHEDULER,
        options: [
            {name: 'Vedi Tutti', field: 'viewJustMe', value: 0}, 
            {name: 'Vista Singola', field: 'viewJustMe', value: 1}, 
            {name: 'Inserimento', field: 'allowInsert', value: 1}, 
            {name: 'Modifica', field: 'allowEdit', value: 1}
        ]
    },
    {
        id: 2,
        title: 'Gestione Salone',
        link: ROUTES.SALON_MANAGEMENT,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 3,
        title: 'Clienti',
        link: ROUTES.CLIENTS,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 4,
        title: 'Pagamenti',
        link: ROUTES.PAYMENTS,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 5,
        title: 'Statistiche',
        link: ROUTES.STATISTICS,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 6,
        title: 'Notifiche',
        link: ROUTES.NOTIFICATION,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 7,
        title: 'Comunicazioni',
        link: ROUTES.COMMUNICATIONS,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 8,
        title: 'Shop',
        link: ROUTES.SHOP,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 9,
        title: 'Recensioni',
        link: ROUTES.REVIEWS,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
    {
        id: 10,
        title: 'Pubblicità',
        link: ROUTES.ADVERTISING,
        options: [{name: 'Tutte le operazioni', field: 'allowAll', value: 1}]
    },
];

export const getSubSections = (section) => {
  const { t } = useTranslation();
    let subSections = [];

    if(section.allowAll==1) {
      subSections.push(t('settings.sectionsButtonSelector.options.allOperations'));
        return subSections;
    }

  if(section.viewJustMe==1) subSections.push(t('settings.sectionsButtonSelector.options.singleView'));
  else subSections.push(t('settings.sectionsButtonSelector.options.viewAll'));

  if(section.allowInsert==1) subSections.push(t('settings.sectionsButtonSelector.options.insert'));

  if(section.allowEdit==1) subSections.push(t('settings.sectionsButtonSelector.options.edit'));

    return subSections;
}
